module.exports = __webpack_public_path__ + "img/6.505ba2a5.jpg";